import type {
	LabelsValue,
	LabelOption as Option,
	ColoredLabel,
} from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
import type {
	Label,
	LabelsSuggestionList,
} from '@atlassian/jira-shared-types/src/rest/jira/label.tsx';
import { GREY_META } from '@atlassian/jira-option-color-picker/src/color-picker/constants.tsx';

export const mapDataToLabelOptions = (data: LabelsValue): Option[] => {
	if (!data) {
		return [];
	}

	return data.map((value) => {
		if (typeof value !== 'string') {
			return {
				value: value.name,
				label: value.name,
				...(value.color ? { color: value.color } : {}),
			};
		}
		return {
			value,
			label: value,
		};
	});
};

export const mapLabelOptionsToData = (options: Option[]): Label[] =>
	options.map(({ value }) => value);

export const mapLabelOptionsToLabelPropertiesForJWMForm = (
	options: Option[],
): { labels: string[]; labelProperties: ColoredLabel[] } => {
	const labels: Label[] = [];
	const labelProperties = options?.map((option) => {
		// @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
		const optionLabel: string = option?.label;
		labels.push(optionLabel);

		if (option?.color) {
			return { name: optionLabel, color: option?.color };
		}

		return {
			name: optionLabel,
			...(option?.__isNew__ ? { color: GREY_META.name } : {}),
		};
	});

	return { labels, labelProperties };
};

export const mapLabelOptionsToLabelData = (options: Option[]) => {
	return [
		{
			operation: 'edit',
			value: options?.map(({ label, color, __isNew__ }) => {
				if (color) {
					return { name: label, color };
				}
				return { name: label, ...(__isNew__ ? { color: GREY_META.name } : {}) };
			}),
		},
		{
			operation: 'set',
			value: options?.map((option) => option.label),
		},
	];
};

export const mapLabelsResponseToLabelOptions = (response: LabelsSuggestionList): Option[] => {
	const { suggestions } = response;

	if (!suggestions) {
		return [];
	}

	return suggestions.map(({ label, color }) => ({
		label,
		value: label,
		...(color ? { color } : {}),
	}));
};
